"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Analytics Events
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnumEntryPoint = void 0;
exports.EnumEntryPoint = {
    Medications: 'Medications',
    Contacts: 'Contacts',
    AddDocument: 'AddDocument',
    EditDocument: 'EditDocument',
    ListView: 'ListView',
    Dashboard: 'Dashboard',
    Profile: 'Profile',
    Resources: 'Resources',
    Tasks: 'Tasks',
    Registration: 'Registration',
    StandaloneVerifyFlow: 'StandaloneVerifyFlow',
    Condition: 'Condition',
    Task: 'Task',
    Document: 'Document',
    Contact: 'Contact',
    Vitals: 'Vitals',
    Other: 'Other',
};
//# sourceMappingURL=enum-entry-point.js.map